import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import _ from 'lodash'

import {
  Button, Typography, Snackbar, TextField, CircularProgress,
  Card, CardContent, CardActions, LinearProgress
} from '@material-ui/core'

import { Box } from 'swx-atomic-component-lib'

import { loadSiteApplication, addSiteApplication, updateSiteApplication } from '../actions/siteapplications'
import i18n from '../i18n'

class SiteApplication extends Component {
  state = {
    clientId: '',
    name: '',
    description: '',
    clientSecret: '',
    imageUrl: '',
    baseUrl: '',
    callbackUrl: '',
    webhookUrl: '',
    sysadminUrl: '',
    orderingNumber: '',
    errors: {}
  }

  constructor (props) {
    super(props)
    this.initState = this.state
  }

  componentDidMount = () => {
    const { id } = this.props.match.params
    if (id) {
      this.setState({ id, isEditMode: true, isProcessing: true })
      this.props.loadSiteApplication(id).then(() => {
        this.setState({ ...this.props.siteApplication, isProcessing: false })
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const data = {
      client_id: this.state.clientId,
      name: this.state.name,
      description: this.state.description,
      image_url: this.state.imageUrl,
      base_url: this.state.baseUrl,
      callback_url: this.state.callbackUrl,
      webhook_url: this.state.webhookUrl,
      sysadmin_url: this.state.sysadminUrl || null,
      ordering_number: this.state.orderingNumber
    }

    this.setState({ isProcessing: true })
    const p = !this.state.isEditMode ? this.props.addSiteApplication(data) : this.props.updateSiteApplication(this.state.id, data)

    p.then(() => {
      let state = { ...this.props.siteApplication, isProcessing: false, isSnackbarOpen: true }
      if (!this.state.isEditMode) {
        state = { ...state, ...this.initState }
      }
      this.setState(state)
    }, err => {
      console.log(err)
      this.setState({ isProcessing: false, errors: this.props.siteApplication.errors, isSnackbarOpen: true })
    })
  }

  handleChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value
    this.setState(state)
  }

  handleCancelClick = (e) => {
    this.setState({ redirectTo: '/applications' })
  }

  handleSnackbarClose = (e) => {
    this.setState({ isSnackbarOpen: false })
  }

  render () {
    const { errors } = this.state

    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} />
    }

    return (
      <Box w='100%' display='flex' justifyContent='center'>
        <Box w='50%'>
          <Typography variant='h5'>
            <span>{this.state.isEditMode ? i18n.application.form.edit : i18n.application.form.add}</span> {i18n.application.form.header}
          </Typography>
          <Card>
            {/* eslint-disable no-prototype-builtins */}
            {this.state.isProcessing && <LinearProgress variant='indeterminate' />}
            <form onSubmit={this.handleSubmit}>
              <CardContent>
                <TextField
                  error={errors.hasOwnProperty('clientId')}
                  id='clientId'
                  name='clientId'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.clientId}
                  margin='normal'
                  helperText={errors.hasOwnProperty('clientId') && errors.clientId}
                  fullWidth
                  required
                  value={this.state.clientId}
                  autoFocus
                />
                <TextField
                  error={errors.hasOwnProperty('name')}
                  id='name'
                  name='name'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.name}
                  margin='normal'
                  helperText={errors.hasOwnProperty('name') && errors.name}
                  fullWidth
                  inputProps={{ maxLength: 30 }}
                  required
                  value={this.state.name}
                  autoFocus
                />
                <TextField
                  error={errors.hasOwnProperty('description')}
                  id='description'
                  name='description'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.description}
                  margin='normal'
                  helperText={errors.hasOwnProperty('description') && errors.description}
                  fullWidth
                  value={this.state.description}
                  required
                />
                <TextField
                  error={errors.hasOwnProperty('baseUrl')}
                  id='baseUrl'
                  name='baseUrl'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.baseUrl}
                  margin='normal'
                  helperText={errors.hasOwnProperty('baseUrl') && errors.baseUrl}
                  fullWidth
                  value={this.state.baseUrl}
                  required
                />
                <TextField
                  error={errors.hasOwnProperty('callbackUrl')}
                  id='callbackUrl'
                  name='callbackUrl'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.callbackUrl}
                  margin='normal'
                  helperText={errors.hasOwnProperty('callbackUrl') && errors.callbackUrl}
                  fullWidth
                  value={this.state.callbackUrl}
                  required
                />
                <TextField
                  error={errors.hasOwnProperty('webhookUrl')}
                  id='webhookUrl'
                  name='webhookUrl'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.webhookUrl}
                  margin='normal'
                  helperText={errors.hasOwnProperty('webhookUrl') && errors.webhookUrl}
                  fullWidth
                  value={this.state.webhookUrl}
                  required
                />
                <TextField
                  error={errors.hasOwnProperty('imageUrl')}
                  id='imageUrl'
                  name='imageUrl'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.imageUrl}
                  margin='normal'
                  helperText={errors.hasOwnProperty('imageUrl') && errors.imageUrl}
                  fullWidth
                  value={this.state.imageUrl}
                  required
                />
                <TextField
                  error={errors.hasOwnProperty('sysadminUrl')}
                  id='sysadminUrl'
                  name='sysadminUrl'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.sysadminUrl}
                  margin='normal'
                  helperText={errors.hasOwnProperty('sysadminUrl') && errors.sysadminUrl}
                  fullWidth
                  value={this.state.sysadminUrl}
                />
                <TextField
                  error={errors.hasOwnProperty('orderingNumber')}
                  id='orderingNumber'
                  name='orderingNumber'
                  onChange={this.handleChange}
                  type='text'
                  label={i18n.application.form.inputLabel.orderingNumber}
                  margin='normal'
                  helperText={errors.hasOwnProperty('orderingNumber') && errors.orderingNumber}
                  fullWidth
                  value={this.state.orderingNumber}
                  required
                />
              </CardContent>
              <CardActions className='align-right'>
                <Button onClick={this.handleCancelClick}>{i18n.common.button.cancel}</Button>
                {
                  this.state.isProcessing
                    ? <Button type='submit' variant='contained' color='primary' disabled> <CircularProgress size={25} /> &nbsp;{i18n.application.form.button.processing}</Button>
                    : <Button type='submit' variant='contained' color='primary'>{i18n.common.button.save}</Button>
                }
              </CardActions>
            </form>
          </Card>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={this.state.isSnackbarOpen}
            autoHideDuration={3000}
            onClose={this.handleSnackbarClose}
            ContentProps={{
              'aria-describedby': 'message-id'
            }}
            message={<span id='message-id'>{_.isEmpty(errors) ? i18n.application.form.notification.success : i18n.application.form.notification.fail}</span>}
          />
        </Box>
      </Box>
    )
  }
}

function mapStateToProps (state) {
  return {
    siteApplication: state.siteApplication
  }
}

export default connect(mapStateToProps, {
  loadSiteApplication,
  addSiteApplication,
  updateSiteApplication
})(SiteApplication)
